exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-item-rating .details .trait-class {\n  font-family: \"Bureau Grot Bk\", helvetica;\n  font-weight: 400;\n  font-size: 12px;\n  display: inline-block;\n  font-style: normal;\n}", ""]);

// exports
